import { useDispatch } from 'react-redux'
import styles from './popups.module.css'
import { removeFriend } from '../../features/friendSlice'
import { ViewProfileRedirect } from './ViewProfileRedirect'
import CommonDeleteModal from '../atoms/modal/CommonDeleteModal'
import ButtonCustom from '../atoms/button/ButtonCustom'

export const RemoveFriendPopup = ({
	clickHandler,
	friend = {},
	removingFriend = false,
}) => {
	const dispatch = useDispatch()

	const hasUserId = Boolean(friend?._id)

	const displayName =
		friend?.businessName ||
		friend?.preferredName ||
		(friend?.firstName || friend?.lastName
			? `${friend?.firstName ?? ''} ${friend?.lastName ?? ''}`.trim()
			: '') ||
		friend?.email ||
		'this person'

	const handleRemove = () => {
		if (friend._id) {
			dispatch(removeFriend(friend._id))
		} else {
			console.warn('RemoveFriendPopup: no identifier to remove', friend)
		}

		clickHandler?.()
	}

	const headingContent = (
		<>
			Would you like to remove{' '}
			{hasUserId ? (
				<ViewProfileRedirect id={friend._id} name={displayName} />
			) : (
				<span>{displayName}</span>
			)}{' '}
			as a friend?
		</>
	)

	return (
		<CommonDeleteModal
			open={removingFriend}
			handleClose={clickHandler}
			heading={headingContent}
			className={styles.deleteModal}
			ClassIcon={styles.detailModalIcon}
			footerContent={
				<>
					<ButtonCustom
						variant="outlined"
						type="button"
						size="lg"
						onClick={clickHandler}
					>
						Cancel
					</ButtonCustom>
					<ButtonCustom
						variant="destructive"
						size="lg"
						onClick={handleRemove}
					>
						Remove
					</ButtonCustom>
				</>
			}
		></CommonDeleteModal>
	)
}
